export const TABLE_NAME = "CAMPAIGN_HISTORY";
export const CREATIVE_TABLE_NAME = "CREATIVE_HISTORY";

export const COLUMNS = [
  "DATETIME",
  "CAMPAIGN_ID",
  "LINEITEM_ID",
  "FIELD_PATH",
  "CHANGE_TYPE",
  "PREVIOUS_VALUE",
  "NEW_VALUE",
  "USER",
  "ARRAY_ADDED",
  "ARRAY_REMOVED",
] as const;

export const CREATIVE_COLUMNS = [
  "DATETIME",
  "CREATIVE_ID",
  "OLD_SNAPSHOT_ID",
  "NEW_SNAPSHOT_ID",
  "FIELD_PATH",
  "CHANGE_TYPE",
  "PREVIOUS_VALUE",
  "NEW_VALUE",
  "USER",
  "ARRAY_ADDED",
  "ARRAY_REMOVED",
] as const;

export const COLUMN_INDEX_MAP = COLUMNS.reduce((acc, column, index) => {
  acc[column] = index;
  return acc;
}, {} as Record<(typeof COLUMNS)[number], number>);

export const CREATIVE_COLUMN_INDEX_MAP = CREATIVE_COLUMNS.reduce(
  (acc, column, index) => {
    acc[column] = index;
    return acc;
  },
  {} as Record<(typeof CREATIVE_COLUMNS)[number], number>
);

export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export type RawHistoryRow = {
  datetime: string;
  campaignId: string;
  lineitemId: string;
  fieldPath: string;
  changeType: string;
  previousValue: string;
  newValue: string;
  user: string;
  arrayAdded: string;
  arrayRemoved: string;
};

export type RawCreativeHistoryRow = {
  datetime: string;
  creativeId: string;
  oldSnapshotId: string;
  newSnapshotId: string;
  fieldPath: string;
  changeType: string;
  previousValue: string;
  newValue: string;
  user: string;
  arrayAdded: string;
  arrayRemoved: string;
};
